import { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { MainBody } from "../../../components/MainBody";
import { TabBar } from "../../../components/TabBar";
import { TabItem } from "../../../components/TabItem";
import { HobbyPricing } from "./HobbyPricing";
import { SkillPricing } from "./SkillPricing";
import { SubjectPricing } from "./SubjectPricing";

export function Pricing() {
  const [activeTab, setActiveTab] = useState("subjects");
  const [searchParams, setSearchParams] = useSearchParams();

  const onTabChange = (newValue: string) => {
    setSearchParams({ type: newValue });
  }


  useEffect(() => {
    let activeType = searchParams.get("type");
    if (activeType) {
      setActiveTab(activeType);
    } else {
      setActiveTab("subjects")
    }
  }, [searchParams]);

  return (
    // <MainBody>
      <div className="relative w-full flex flex-col p-2 bg-white">
        <h1 className="text-xl font-semibold my-5">Pricing Settings</h1>

        <TabBar
          value={activeTab}
          onChange={onTabChange}
          textColor="text-black"
          indicatorColor="text-primary">
          <TabItem value={"subjects"} label="Subjects" />
          <TabItem value={"hobbies"} label="Hobbies" />
          <TabItem value={"skills"} label="Skills" />
        </TabBar>

        {activeTab === "hobbies" &&
          <HobbyPricing />
        }
        {activeTab === "subjects" &&
          <SubjectPricing />
        }
        {activeTab === "skills" &&
          <SkillPricing />
        }
      </div>
    // </MainBody>
  )
}


